import PropTypes from 'prop-types';

const CompactView = ({ color, size, ...props }) => (
    <svg viewBox="0 0 18 18" width={size} height={size} {...props}>
        <path
            d="M9 15a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1M13 15a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1M17 15a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v10a1 1 0 0 1-1 1M5 15a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v10a1 1 0 0 1-1 1M1 15a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1"
            fill={color}
            fillRule="evenodd"
        />
    </svg>
);

export default CompactView;

CompactView.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
